<page-heading
  [title]="'report.salesMonitor.pageTitle' | translate"
  [description]="'report.salesMonitor.pageDescription' | translate"
  [hasBreadcrumb]="true"
  [breadcrumb]="breadcrumb"
/>

<div class="row">
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <form [formGroup]="formGroup">
          <div class="row g-2">
            <div class="col-xs-12 col-lg-6 input-trend-search">
              <input
                type="search"
                #searchBox
                class="form-control"
                [placeholder]="'report.salesMonitor.searchPlaceholder' | translate"
                (keyup)="search(searchBox.value)"
              />
              <span class="mdi mdi-magnify search-icon ml-2"></span>
            </div>
            <div class="col-xs-12 col-lg-3 trend-datepicker">
              <mat-date-range-input
                [rangePicker]="picker"
                formGroupName="dateRange"
              >
                <input
                  matStartDate
                  [placeholder]="'report.salesMonitor.startDate' | translate"
                  formControlName="dateStart"
                />
                <input
                  matEndDate
                  [placeholder]="'report.salesMonitor.endDate' | translate"
                  formControlName="dateEnd"
                />
              </mat-date-range-input>
              <mat-datepicker-toggle matIconSuffix [for]="picker" />
              <mat-date-range-picker #picker>
                <mat-datepicker-actions>
                  <mat-select
                    class="input-field rounded-lg"
                    (selectionChange)="onPeriodChange($event)"
                    [placeholder]="'report.salesMonitor.selectPlaceholder' | translate"
                  >
                    <mat-option value="1">{{ 'report.salesMonitor.today' | translate }}</mat-option>
                    <mat-option value="7">{{ 'report.salesMonitor.last7Days' | translate }}</mat-option>
                    <mat-option value="15">{{ 'report.salesMonitor.last15Days' | translate }}</mat-option>
                    <mat-option value="30">{{ 'report.salesMonitor.last30Days' | translate }}</mat-option>
                    <mat-option value="60">{{ 'report.salesMonitor.last60Days' | translate }}</mat-option>
                  </mat-select>
                  <button mat-raised-button matDatepickerApply class="btnOk">
                    OK
                  </button>
                </mat-datepicker-actions>
              </mat-date-range-picker>
            </div>
            <div
              class="col-xs-6 col-md-6 col-lg-3 gap-2 btn-group trend-button"
            >
              <button
                class="btn btn-primary fw-bold"
                [disabled]="isLoading"
                [ngClass]="{
                  'cursor-not-allowed opacity-50': isLoading,
                  'cursor-pointer': !isLoading
                }"
                (click)="exportAttendanceReportToExcel()"
                [matTooltip]="'report.salesMonitor.exportToExcel' | translate"
              >
                @if (isLoading) {
                <mat-spinner [diameter]="25" mode="indeterminate"></mat-spinner>
                } @else {
                <i class="ri-file-text-line"></i>
                }
              </button>

              <button
                class="btn btn-primary fw-bold"
                [disabled]="isLoading"
                [ngClass]="{
                  'cursor-not-allowed opacity-50': isLoading,
                  'cursor-pointer': !isLoading
                }"
                [matTooltip]="'report.salesMonitor.exportToPdf' | translate"
                (click)="exportAttendanceReportToPDF()"
              >
                @if (isLoading) {
                <mat-spinner [diameter]="25" mode="indeterminate"></mat-spinner>
                } @else {
                <i class="ri-share-box-fill"></i>
                }
              </button>
            </div>
          </div>

          <div class="row g-2 mt-2">
            <div class="col-xs-12 col-md-6 col-xl-3 btn-group trend-button">
              <button
                [matMenuTriggerFor]="filterChannel"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>{{ labelChannel | translate }}</span>
              </button>
              <mat-menu #filterChannel="matMenu">
                @if (listChannel.length > 0) {
                <button mat-menu-item (click)="searchByChannel(null)">
                  {{ 'report.salesMonitor.all' | translate }}
                </button>
                @for (channel of listChannel; track $index) {
                <button mat-menu-item (click)="searchByChannel(channel)">
                  {{ channel.name }}
                </button>
                } } @else {
                <h6 class="text-muted m-1">{{ 'report.salesMonitor.noResultsFound' | translate }}</h6>
                }
              </mat-menu>
            </div>
            <div
              class="col-xs-12 col-md-6 col-lg-6 col-xl-3 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterDepartmentAtt"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant d-block dropdown-toggle"
              >
                <span>{{ labelDepartment | translate }}</span>
              </button>
            </div>
            <mat-menu #filterDepartmentAtt="matMenu" class="custom-menu-panel">
              <button mat-menu-item (click)="searchByDepartment(null)">
                {{ 'report.salesMonitor.all' | translate }}
              </button>
              @for (department of listDepartmentChannel; track $index) {
              <button mat-menu-item (click)="searchByDepartment(department)">
                {{ department.name }}
              </button>
              }
            </mat-menu>

            <div
              class="col-xs-12 col-md-6 col-lg-4 col-xl-3 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterSalesMonitorStatus"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant d-block dropdown-toggle"
              >
                <span>{{ labelSalesMonitor | translate }}</span>
              </button>
            </div>
            <mat-menu
              #filterSalesMonitorStatus="matMenu"
              class="custom-menu-panel"
            >
              <button mat-menu-item (click)="searchBySalesMonitor(null)">
                {{ 'report.salesMonitor.all' | translate }}
              </button>
              @for (sm of listSalesMonitorChanel; track $index) {
              <button mat-menu-item (click)="searchBySalesMonitor(sm)">
                <span
                  [ngClass]="{
                  'text-success': sm.saleClosed && !sm.saleLost,
                  'text-danger': sm.saleLost && !sm.saleClosed,
                }"
                >
                  {{ sm.name }}
                </span>
              </button>
              }
            </mat-menu>

            <div
              class="col-xs-12 col-md-6 col-lg-4 col-xl-3 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterUserAdm"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>{{ labelUser | translate }}</span>
              </button>
            </div>
            <mat-menu #filterUserAdm="matMenu" class="custom-menu-panel">
              <button mat-menu-item (click)="searchByUser(null)">{{ 'report.salesMonitor.all' | translate }}</button>
              @for (user of attendantsByTeam; track $index) {
              <button mat-menu-item (click)="searchByUser(user)">
                {{ user.name }}
              </button>
              }
            </mat-menu>
            @if (isSupervisor()) {
            <div
              class="col-xs-12 col-md-6 col-lg-4 col-xl-3 btn-group trend-button"
            >
              <button
                [matMenuTriggerFor]="filterUserSup"
                type="submit"
                class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle"
              >
                <span>{{ labelUser | translate }}</span>
              </button>
            </div>
            <mat-menu #filterUserSup="matMenu" class="custom-menu-panel">
              <button mat-menu-item (click)="searchByUser(null)">{{ 'report.salesMonitor.all' | translate }}</button>
              @for (user of attendantsByTeam; track $index) { @for (user of user.agents;
              track $index) {
              <button mat-menu-item (click)="searchByUser(user)">
                {{ user.name }}
              </button>
              } }
            </mat-menu>
            }
          </div>
        </form>
      </div>
    </div>

    @if (!loadingContent && pager.total > 0) {
      <div class="card-body mb-3">
        <div class="row d-flex g-3">
          <div class="col-xs-12 col-lg-6 col-xl-3">
            <card-graphic-small-component
              [label]="'report.salesMonitor.kpiTotalSales' | translate"
              [total]="salesMonitorKpis?.totalSales.toString()"
              [icon]="'group'"
              class="w-full"
            />
          </div>

          <div class="col-xs-12 col-lg-6 col-xl-3">
            <card-graphic-small-component
              [label]="'report.salesMonitor.kpiTotalGenerated' | translate"
              [total]="salesMonitorKpis?.totalGenerated.toString()"
              [icon]="'attach_money'"
              class="w-full"
            />
          </div>
          <div class="col-xs-12 col-lg-6 col-xl-3">
            <card-graphic-small-component
              [label]="'report.salesMonitor.kpiClosedSales' | translate"
              [total]="salesMonitorKpis?.closedSales.toString()"
              [icon]="'done_all'"
              class="w-full"
            />
          </div>

          <div class="col-xs-12 col-lg-6 col-xl-3">
            <card-graphic-small-component
              [label]="'report.salesMonitor.kpiConversionRate' | translate"
              [total]="$safeNavigationMigration(salesMonitorKpis?.conversionRate)"
              [icon]="'show_chart'"
              class="w-full"
            />
          </div>

          <div class="col-xs-12 col-lg-6 col-xl-3">
            <card-graphic-small-component
              [label]="'report.salesMonitor.kpiSalesLost' | translate"
              [total]="salesMonitorKpis?.salesLost.toString()"
              [icon]="'cancel'"
              class="w-full"
            />
          </div>

          <div class="col-xs-12 col-lg-6 col-xl-3">
            <card-graphic-small-component
              [label]="'report.salesMonitor.kpiTotalLost' | translate"
              [total]="$safeNavigationMigration(salesMonitorKpis?.totalLost)"
              [icon]="'money_off'"
              class="w-full"
            />
          </div>

          <div class="col-xs-12 col-lg-6 col-xl-3">
            <card-graphic-small-component
              [label]="'report.salesMonitor.kpiTotalEarned' | translate"
              [total]="$safeNavigationMigration(salesMonitorKpis?.totalEarned)"
              [icon]="'monetization_on'"
              class="w-full"
            />
          </div>

          <div class="col-xs-12 col-lg-6 col-xl-3">
            <card-graphic-small-component
              [label]="'report.salesMonitor.kpiConversionRateByValue' | translate"
              [total]="$safeNavigationMigration(salesMonitorKpis?.conversionRateByValue)"
              [icon]="'bar_chart'"
              class="w-full"
            />
          </div>
        </div>
      </div>
    }
  </div>
</div>

@if (!loadingContent && pager.total > 0) {
  <div class="card">
    <div class="card-body mb-3">
      <div class="row">
        <div class="col-xs-12 col-lg-7">
          <span class="text-muted fw-bold fs-4"
            >{{ 'report.salesMonitor.chartTotalByStatus' | translate }}</span
          >
          <div class="card mt-2">
            <ngx-charts-bar-vertical-2d
              [results]="salesMonitorToBarChart"
              [customColors]="customColors"
              [xAxis]="true"
              [yAxis]="true"
              [roundEdges]="true"
              [showYAxisLabel]="true"
              [yAxisLabel]="'report.salesMonitor.chartYAxisValue' | translate"
              [roundDomains]="true"
              style="width: 100%; height: 200px"
            >
            </ngx-charts-bar-vertical-2d>
          </div>
        </div>
        <div class="col-xs-12 col-lg-5">
          <span class="text-muted fw-bold fs-4">{{ 'report.salesMonitor.chartSalesBySource' | translate }}</span>
          <div class="card mt-2">
            <ngx-charts-advanced-pie-chart
              [results]="salesBySourceChart"
              [customColors]="customColors"
              [labels]="true"
              [explodeSlices]="false"
              style="width: 100%; height: 200px"
            >
            </ngx-charts-advanced-pie-chart>
          </div>
        </div>
      </div>
    </div>
  </div>
}

<div class="card">
  @if (loadingContent) {
  <content-loading-list></content-loading-list>
  }
  @if (!loadingContent && pager.total === 0) {
    <empty-records-component
      [message]="'report.salesMonitor.emptyMessage' | translate"
      [subMessage]="'report.salesMonitor.emptySubMessage' | translate"
      [icon]="'mdi mdi-alert-circle-outline'"
    />
  }

  @if (!loadingContent && pager.total > 0) {
    <div class="card-body table-responsive">
      <table class="table table-hover table-centered mb-0">
        <thead>
          <tr>
            <th class="text-primary-emphasis">{{ 'report.salesMonitor.tableClient' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'report.salesMonitor.tablePhone' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'report.salesMonitor.tableChannel' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'report.salesMonitor.tableDepartment' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'report.salesMonitor.tableAttendant' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'report.salesMonitor.tableStatus' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'report.salesMonitor.tableSource' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'report.salesMonitor.tableSaleStatus' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'report.salesMonitor.tableBudget' | translate }}</th>
            <th class="text-primary-emphasis">{{ 'report.salesMonitor.tableClosedAt' | translate }}</th>
            <th><span class="sr-only"></span></th>
          </tr>
        </thead>
        <tbody>
          @for (item of pager.list; track item) {
            <tr>
              <td>
                <span>
                  @if (item?.contact?.name?.length > 15) {
                  <span matTooltip="{{ item?.contact?.name }}">
                    {{ $safeNavigationMigration(item?.contact?.name) | truncate : 15 }}
                  </span>
                  } @else {
                  <span>
                    {{ item?.contact?.name }}
                  </span>
                  }</span
                >
              </td>
              <td>
                <span>
                  @if (item?.contact?.phone?.length > 15) {
                  <span matTooltip="{{ item?.contact?.phone }}">
                    {{ $safeNavigationMigration(item?.contact?.phone) | truncate : 15 }}
                  </span>
                  } @else {
                  <span>
                    {{ item?.contact?.phone }}
                  </span>
                  }</span
                >
              </td>
              <td>
                <span>
                  @if (!!item?.channel?.name) {
                  <span class="text-[16px]" matTooltip="{{ item.channel?.name }}">
                    {{ $safeNavigationMigration(item.channel?.name) | truncate : 10 }}
                  </span>
                  } @else {
                  <span class="text-[16px]" matTooltip="{{ item?.channel?.name }}">
                    {{ $safeNavigationMigration(item?.channel?.name) | truncate : 10 }}
                  </span>
                  }
                </span>
              </td>
              <td>
                @if (!!item?.department?.name) {@if(item?.department?.name?.length
                > 10) {
                <span matTooltip="{{ item?.department?.name }}">
                  {{ item?.department?.name ?? "-" | truncate : 10 }}
                </span>
                } @if (item?.department?.name?.length <= 10) {
                <span>
                  {{ item?.department?.name ?? "-" }}
                </span>
                } } @else {
                <span>-</span>
                }
              </td>
              <td>
                @if (!!item?.user?.name) { @if(item?.user?.name?.length > 10) {
                <span matTooltip="{{ item?.user?.name }}">
                  {{ item?.user?.name ?? "-" | truncate : 10 }}
                </span>
                } @if (item?.user?.name?.length <= 10) {
                <span>
                  {{ item?.user?.name ?? "-" }}
                </span>
                } } @else {
                <span>-</span>
                }
              </td>
              <td class="position-relative">
                <div class="d-flex flex-column gap-1">
                  <span
                    class="badge text-capitalize font-14"
                    [ngClass]="{
                      'bg-success': item?.status === 'IN_PROGRESS',
                      'bg-warning': item?.status === 'PENDING',
                      'bg-danger': item?.status === 'OVERTIME',
                      'bg-primary': item?.status === 'PAUSED',
                      'bg-secondary': item?.status === 'CLOSED'
                    }"
                  >
                    {{ translateStatus($safeNavigationMigration(item?.status)) }}
                  </span>
                  @if(item?.status === 'PENDING' && item?.chatbotStatus?.automated)
                  {
                  <span
                    class="badge bg-dark p-1 rounded-pill badge-position translate-middle"
                  >
                    Chatbot
                  </span>
                  }
                </div>
              </td>
              <td>
                @if (getLeadSource(item.contact)?.length > 15) {
                <span matTooltip="{{ getLeadSource(item.contact) }}">
                  {{ getLeadSource(item.contact) | truncate : 15 }}
                </span>
                } @else {
                <span>
                  {{ getLeadSource(item.contact) ?? "-" }}
                </span>
                }
              </td>
              <td>
                <span>
                  @if (item?.salesMonitorStatus?.salesMonitor?.saleClosed) {
                  <span class="bg-success badge text-capitalize font-14">
                    {{ item?.salesMonitorStatus?.salesMonitor?.name || "-" }}
                  </span>
                  } @if (item?.salesMonitorStatus?.salesMonitor?.saleLost) {
                  <span class="bg-danger badge text-capitalize font-14">
                    {{ item?.salesMonitorStatus?.salesMonitor?.name || "-" }}
                  </span>
                  } @if (!item?.salesMonitorStatus?.salesMonitor?.saleClosed &&
                  !item?.salesMonitorStatus?.salesMonitor?.saleLost) {
                  <span
                    class="bg-secondary badge text-capitalize font-14"
                  >
                    {{ item?.salesMonitorStatus?.salesMonitor?.name || "-" }}
                  </span>
                  }
                </span>
              </td>
              <td>
                {{
                  $safeNavigationMigration(item?.salesMonitorStatus?.budget)
                    | currency : "BRL" : "symbol" : "1.2-2"
                }}
              </td>
              <td>
                {{ $safeNavigationMigration(item?.salesMonitorStatus?.closedAt) | date : "dd/MM/yyyy" }}
              </td>
              <td>
                <div class="d-flex justify-content-end">
                  <button 
                    type="button"
                    class="btn btn-dropdown-list" 
                    [matMenuTriggerFor]="menu" 
                  >
                    <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
                  </button>

                  <mat-menu #menu="matMenu">
                    <button mat-menu-item tabindex="0" (click)="notify(item)">{{ 'report.salesMonitor.view' | translate }}</button>
                  </mat-menu>
                </div>
              </td>
            </tr>
          }
        </tbody>
      </table>

      @if (pager.total > pager.perPage) {
      <paginator [pager]="pager" (onPager)="loadPage($event)"></paginator>
      }
    </div>
  }
</div>
